import {Construtor} from './construtor';
import {PontoFisico} from './ponto-fisico';
import { AgendaRoteiroPontoFisico } from './agenda-roteiro-ponto-fisico';

export class RoteiroPontoFisico implements Construtor<RoteiroPontoFisico> {

  public idRoteiroPontoFisico: number;
  public idRoteiro: number;
  public pontoFisico: PontoFisico;
  public agendas: AgendaRoteiroPontoFisico[];
  public selecionado: boolean;
  public alterado: boolean;

  constructor(object?: any) {
    this.pontoFisico = new PontoFisico();
    this.agendas = new Array<AgendaRoteiroPontoFisico>();

    if (object !== undefined && object !== null) {

      if (object instanceof RoteiroPontoFisico) {
        this.copyObject(object);
      } else if (object instanceof (PontoFisico)) {
        this.pontoFisico = object;
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }

    return this;
  }

  get obterIdRoteiroPontoFisico(): number {
    return this.idRoteiroPontoFisico;
  }

  set IdRoteiroPontoFisico(id: any) {
    this.idRoteiroPontoFisico = id;
  }

  get obterIdRoteiro(): number {
    return this.idRoteiro;
  }

  set IdRoteiro(id: any) {
    this.idRoteiro = id;
  }

  get obterPontoFisico(): PontoFisico {
    return this.pontoFisico;
  }

  set PontoFisico(ponto: any) {
    this.pontoFisico = ponto;
  }

  get obterAgendas(): AgendaRoteiroPontoFisico[] {
      return this.agendas;
  }

  set Agendas(agendas: any) {
      this.agendas = agendas;
  }

  copyObject(roteiro: RoteiroPontoFisico): void {
    this.idRoteiroPontoFisico = roteiro.obterIdRoteiroPontoFisico;
    this.idRoteiro = roteiro.obterIdRoteiro;
    this.pontoFisico = roteiro.obterPontoFisico;
    this.agendas = roteiro.obterAgendas;
  }

  parseFromJson(roteiro: any): void {
    this.IdRoteiroPontoFisico = roteiro.idRoteiroPontoFisico;
    this.IdRoteiro = roteiro.idRoteiro;
    this.PontoFisico = roteiro.pontoFisico;
    this.Agendas = roteiro.agendas;
  }

  modeloCompleto(): boolean {
    return this.IdRoteiro !== undefined;
  }

  getNewInstance(object?: any): RoteiroPontoFisico {
    return new RoteiroPontoFisico(object);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/roteiro-ponto-fisico.ts